export default "__VITE_ASSET__Bi3T52oy__"